export const currencyCodeToSymbol = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  RUB: '₽'
};
